const DEFAULT_WAIT_TIMEOUT_MS = 10000;

export default function waitForElement(selector, timeoutMs = DEFAULT_WAIT_TIMEOUT_MS) {
  const el = document.querySelector(selector);
  if (el) return Promise.resolve(el);

  return new Promise((resolve, reject) => {
    let observer = null;
    const timeout = setTimeout(() => {
      observer.disconnect();
      reject(new Error(`Timed out waiting for "${selector}"`));
    }, timeoutMs);

    observer = new MutationObserver(() => {
      const target = document.querySelector(selector);
      if (target) {
        observer.disconnect();
        clearTimeout(timeout);
        resolve(target);
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  });
}
